import type { ClientContact } from '@/shared/types/client-contacts';
import type { Client } from '@/shared/types/clients';

export const mockClients: Client[] = [
  {
    id: 'client_1',
    name: 'Client A',
    email: 'contact@client-a.test',
    phone: '+33 1 00 00 00 00',
    address: '10 rue de Paris, 75001 Paris',
    siret: '12345678901234',
    vatNumber: 'FR12345678901',
    createdAt: '2025-01-15T10:00:00.000Z',
    updatedAt: '2025-01-15T10:00:00.000Z',
  },
  {
    id: 'client_2',
    name: 'Client B',
    email: 'contact@client-b.test',
    phone: '+33 4 00 00 00 00',
    address: '20 avenue de Lyon, 69000 Lyon',
    siret: '12345678901234',
    vatNumber: 'FR12345678901',
    createdAt: '2025-01-15T10:00:00.000Z',
    updatedAt: '2025-01-15T10:00:00.000Z',
  },
];

export const mockClientContacts: ClientContact[] = [
  {
    id: 'contact_1',
    clientId: 'client_1',
    clientName: 'Client A',
    firstName: 'Alice',
    lastName: 'Martin',
    email: 'alice.martin@client-a.test',
    phone: '+33 6 11 11 11 11',
    role: 'Chargée de projet',
    createdAt: '2025-01-15T10:00:00.000Z',
    updatedAt: '2025-01-15T10:00:00.000Z',
  },
  {
    id: 'contact_2',
    clientId: 'client_1',
    clientName: 'Client A',
    firstName: 'Bob',
    lastName: 'Lefebvre',
    email: 'bob.lefebvre@client-a.test',
    phone: '+33 6 22 22 22 22',
    role: 'Directeur technique',
    createdAt: '2025-01-15T10:00:00.000Z',
    updatedAt: '2025-01-15T10:00:00.000Z',
  },
  {
    id: 'contact_3',
    clientId: 'client_2',
    clientName: 'Client B',
    firstName: 'Claire',
    lastName: 'Dubois',
    email: 'claire.dubois@client-b.test',
    phone: '+33 6 33 33 33 33',
    role: 'Responsable achats',
    createdAt: '2025-01-15T10:00:00.000Z',
    updatedAt: '2025-01-15T10:00:00.000Z',
  },
];
